import { connect } from 'react-redux';

import { Promos } from './Promos';
import { IState } from '../../store';
import { IVillageSchema } from '../../types';
import { IPromotions } from '../../types/villagePromotions';
export interface IProps {
  village: IVillageSchema;
  promos: IPromotions[];
}

export function mapStateToProps(state: IState): IProps {
  return {
    village: state.villageData.village,
    promos: state.promotionsVillageData.promotions,
  };
}

export const PromosContainer = connect<IProps>(mapStateToProps)(Promos);
